import styled from 'styled-components';

export const EntryRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 48px 24px;
  box-sizing: border-box;
  background:
    radial-gradient(ellipse 80% 60% at 50% 20%, #2a2a48 0%, transparent 55%),
    radial-gradient(ellipse 70% 50% at 70% 80%, #1a3040 0%, transparent 50%),
    linear-gradient(160deg, #0c0c14 0%, #171720 45%, #0a1218 100%);
  color: #e8e8f0;
  font-family: 'Trebuchet MS', 'Segoe UI', Verdana, sans-serif;
`;

export const Brand = styled.h1`
  margin: 0;
  font-size: clamp(3rem, 8vw, 5.5rem);
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  background: linear-gradient(120deg, #f0f4ff 20%, #7ec8ff 55%, #c9a0ff 90%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const Tagline = styled.p`
  margin: 0;
  font-size: 1.05rem;
  opacity: 0.75;
  letter-spacing: 0.04em;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin-top: 8px;
`;

export const ModeButton = styled.button`
  min-width: 160px;
  padding: 14px 28px;
  border-radius: 4px;
  border: 1px solid ${({ primary }) => (primary ? '#5aa7ff' : '#55556a')};
  background: ${({ primary }) => (primary ? 'rgba(60, 130, 220, 0.35)' : 'rgba(255,255,255,0.04)')};
  color: #f2f2fa;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;

  &:hover {
    background: ${({ primary }) => (primary ? 'rgba(80, 150, 240, 0.5)' : 'rgba(255,255,255,0.1)')};
    border-color: ${({ primary }) => (primary ? '#8ec4ff' : '#8888a0')};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid #7ec8ff;
    outline-offset: 3px;
  }
`;

export const Hint = styled.p`
  margin: 12px 0 0;
  font-size: 0.85rem;
  opacity: 0.45;
  max-width: 320px;
  text-align: center;
  line-height: 1.4;
`;
